import React from "react";
import { useApp } from "../context/AppContext";

export default function ArtistSwitcher() {
  const { portal, activeArtistId, setActiveArtistId } = useApp();
  if (!portal || portal.portalType !== "multi" || (portal.artists || []).length < 2) return null;
  return (
    <div className="px-5 pt-4">
      <div className="flex gap-2 overflow-x-auto no-scrollbar">
        {portal.artists.map((a) => (
          <button
            key={a.id}
            onClick={() => setActiveArtistId(a.id)}
            className={`shrink-0 px-4 h-9 rounded-full text-[13px] font-medium transition-colors ${a.id === activeArtistId ? "bg-white text-black" : "bg-white/[0.06] text-white/65 hover:bg-white/10"}`}
          >
            {a.name}
          </button>
        ))}
      </div>
    </div>
  );
}
